import styled from 'styled-components'

export const ErrorStyled = styled.div`
  // 404 error page
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: black;

  h1 {
    font-size: 5rem;
    font-weight: bold;
    color: #f5f5f5;
    text-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  }
  h2 {
    font-size: 2rem;
    font-weight: bold;
    color: #f5f5f5;
    text-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  }
  h3 {
    font-size: 1.5rem;
    font-weight: bold;
    color: #f5f5f5;
    text-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  }
  a {
    font-size: 1.5rem;
    font-weight: bold;
    color: #f5f5f5;
    text-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  }


  
`
